import { BillingCardResource, BillingInvoiceResource, BillingResource } from "api/resource/billing";

const card: BillingCardResource = {
	paymentType: "card",
	cardType: "Visa",
	lastFour: "4242",
	month: 8,
	year: 2028,
	firstName: "John",
	lastName: "Washington Doe",
	address1: "123 Main St.",
	address2: "",
	city: "Eugene",
	state: "OR",
	zip: "97401",
	country: "US",
};

const eligible: BillingResource = {
	eligible: true,
	billableLeadOwnerCount: 4,
	recurlyAvailable: true,
	subscriptionState: "active",
	nextBillingDate: "2026-11-01",
	card,
	recurlyPublicKey: "ewr1-mock-public-key",
};

/** Switch `billing` below to exercise each state of the Billing tab. */
export const billingScenarios: Record<"eligible" | "noCard" | "recurlyDown" | "resellerBilled" | "notRecurly", BillingResource> = {
	eligible,
	noCard: {
		...eligible,
		card: null,
	},
	recurlyDown: {
		...eligible,
		recurlyAvailable: false,
		nextBillingDate: undefined,
		card: null,
	},
	resellerBilled: {
		eligible: false,
		reason: "RESELLER_BILLED",
		billableLeadOwnerCount: 4,
		recurlyAvailable: true,
	},
	notRecurly: {
		eligible: false,
		reason: "NOT_RECURLY",
		billableLeadOwnerCount: 4,
		recurlyAvailable: true,
	},
};

export const billing: BillingResource = billingScenarios.eligible;

/** Mock mode only: a card token the mock answers with a 422 DECLINED, like Recurly's declining test card. */
export const DECLINED_CARD_TOKEN = "tok_declined";

export const billingInvoices: BillingInvoiceResource[] = [
	{ displayNumber: "1712", issueDate: "2026-10-01", dueDate: "2026-10-01", status: "paid", total: 199, currency: "USD" },
	{ displayNumber: "1655", issueDate: "2026-09-01", dueDate: "2026-09-01", status: "paid", total: 199, currency: "USD" },
	{ displayNumber: "1601", issueDate: "2026-08-01", dueDate: "2026-08-01", status: "past_due", total: 199, currency: "USD" },
	{ displayNumber: "1544", issueDate: "2026-07-01", dueDate: "2026-07-01", status: "failed", total: 199, currency: "USD" },
	{ displayNumber: "1490", issueDate: "2026-06-01", dueDate: "2026-06-01", status: "voided", total: 49.5, currency: "USD" },
	{ displayNumber: "1432", issueDate: "2026-05-01", dueDate: "2026-05-15", status: "open", total: 199, currency: "USD" },
];
